import { render, staticRenderFns } from "./qa-list.vue?vue&type=template&id=34e999bc&scoped=true"
import script from "./qa-list.vue?vue&type=script&lang=js"
export * from "./qa-list.vue?vue&type=script&lang=js"
import style0 from "./qa-list.vue?vue&type=style&index=0&id=34e999bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e999bc",
  null
  
)

export default component.exports